import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/Authentication';
import { clearActionResponse as clearError } from './../../actions/Global';

class Logout extends Component {
  /**
   * Logs the current user out.
   */
  componentDidMount() {
    this.props.logout();
  }

  /**
   * Redirects to start page right after logged out.
   * @returns {*}
   */
  render() {
    return <Redirect to='/' />;
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {};
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{logout: logout}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logout: logout,
      clearError: clearError,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{clearError: shim}}
 */
Logout.propTypes = {
  clearError: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
